import { createContext } from 'react'
import type { MutableRefObject } from 'react'

export type ScrollViewPositionRef = MutableRefObject<number>

export const ScrollViewPositionContext =
  createContext<ScrollViewPositionRef | null>(null)
